// extracted by mini-css-extract-plugin
export default {"socialIcons":"socialIcons_socialIcons__DTvH8","socialIcons__item":"socialIcons_socialIcons__item__6ZpOX"};